import styled from 'styled-components';

export const Wrap = styled.div<{ $cssStyle?: string }>`
  position: relative;
  cursor: pointer;
  &::before {
    content: '';
    position: absolute;
    top: -30px;
    left: -30px;
    right: -30px;
    bottom: -30px;
    background-color: transparent;
  }
  &:hover {
    svg {
      stroke: ${({ theme }) => theme.colors.gp2};
    }
  }
  ${({ $cssStyle }) => $cssStyle}
`;
